(() => {
  const entryHash = "#personalizar";
  let observer;
  let timeout;
  let frame;
  let opening = false;

  function stopWaiting() {
    observer?.disconnect();
    observer = null;
    window.clearTimeout(timeout);
    window.cancelAnimationFrame(frame);
    frame = null;
    opening = false;
    window.removeEventListener("pplrAppInitiated", scheduleOpen);
    window.removeEventListener("pplrAppBuild", scheduleOpen);
  }

  function consumeEntry() {
    stopWaiting();
    if (window.location.hash === entryHash) {
      window.history.replaceState(
        window.history.state,
        "",
        window.location.pathname + window.location.search
      );
    }
  }

  function openPersonalization() {
    frame = null;
    if (window.location.hash !== entryHash) {
      stopWaiting();
      return;
    }

    const main = document.getElementById("MainContent");
    if (!main) return;

    const hasOpenPopup = Array.from(
      document.querySelectorAll(".pplr_crop-modal .pplr-popup")
    ).some((popup) => popup.getClientRects().length);
    if (hasOpenPopup) {
      consumeEntry();
      return;
    }
    if (opening) return;

    const trigger = main.querySelector(
      '.product-personalizer button[type="button"][onclick*="cstmfy_personalize_text"]'
    );
    if (
      trigger &&
      !trigger.disabled &&
      trigger.getClientRects().length &&
      typeof window.cstmfy_personalize_text === "function"
    ) {
      // Use the app's own entry button; never submit the product form here.
      opening = true;
      trigger.click();
      scheduleOpen();
      return;
    }

    // Some personalized products use the theme's inline fields instead of Zepto.
    const fields = main.querySelector("[data-pf-wrap]");
    const usesZepto =
      Number(window.product_personalizer?.cstmfy_req) > 0 ||
      Number(window.product_personalizer?.pplr_req) > 0;
    if (fields && !usesZepto) {
      fields.closest("product-kit-item")?.setAttribute("open", "");
      fields.setAttribute("tabindex", "-1");
      fields.focus({ preventScroll: true });
      fields.scrollIntoView({ block: "center" });
      consumeEntry();
    }
  }

  function scheduleOpen() {
    if (frame == null) frame = window.requestAnimationFrame(openPersonalization);
  }

  function start() {
    if (window.location.hash !== entryHash) {
      stopWaiting();
      return;
    }
    if (observer) return;

    // Zepto is injected asynchronously; cover both its ready event and late DOM insertion.
    observer = new MutationObserver(scheduleOpen);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["disabled", "class", "style", "hidden"],
    });
    window.addEventListener("pplrAppInitiated", scheduleOpen);
    window.addEventListener("pplrAppBuild", scheduleOpen);
    // Stop watching unrelated DOM changes, but still honor a slow app's ready event.
    timeout = window.setTimeout(() => observer?.disconnect(), 30000);
    scheduleOpen();
  }

  window.addEventListener("hashchange", start);
  window.addEventListener("pageshow", start);
  window.addEventListener("pagehide", stopWaiting);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
